<template>
  <PageWrapper
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_DIGITAL_PRODUCTS"
    title="Your Digital Products"
    :breadcrumbs="breadcrumbs"
    page-name="Digital Products"
    align="left"
    width="full"
  >
    <iColumn gap="gigantic">
      <MyPublicationDigitalProducts />
      <MyPublicationSubscriptions />
    </iColumn>
  </PageWrapper>
</template>

<script>
import {
  PAGE_PUBLICATION_DIGITAL_PRODUCTS,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { mapState } from "pinia";

import MyPublicationSubscriptions from "@/components/publication/MyPublicationSubscriptions.vue";
import MyPublicationDigitalProducts from "@/components/publication/MyPublicationDigitalProducts.vue";

import PageWrapper from "@/components/PageWrapper";

export default {
  name: "PublicationDigitalProducts",
  components: {
    PageWrapper,
    MyPublicationSubscriptions,
    MyPublicationDigitalProducts,
  },
  data() {
    return {
      SECTION_PUBLICATIONS,
      PAGE_PUBLICATION_DIGITAL_PRODUCTS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, ["orgId", "publicationId", "publication"]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        {
          url: `/publication/${this.publicationId}`,
          label: this.publication.name,
        },
      ];
    },
  },
};
</script>

<style scoped></style>
